<template>
  <div class="student-profile">
    


    <!-- 体测成绩 -->
    <div v-if="activeTab === 'scores'">
      <el-card class="content-card">
        <div slot="header" class="card-header">
          <span>体测成绩查询</span>
        </div>
        <router-view />
      </el-card>
    </div>
    
    <!-- 内容区域 -->
    <div v-else-if="activeTab === 'info'">
      <el-card class="profile-card">
        <div slot="header" class="card-header">
          <span>个人信息</span>
          <el-button
            type="primary"
            size="small"
            class="edit-btn"
            @click="toggleEdit"
          >
            {{ isEditing ? '取消' : '编辑' }}
          </el-button>
        </div>

        <!-- 欢迎语 -->
        <div class="welcome-section">
          <h2 class="welcome-message">欢迎回来，{{ studentInfo.name || '同学' }}!</h2>
        </div>
        
        <el-form
          ref="profileForm"
          :model="studentInfo"
          :rules="profileRules"
          label-width="120px"
          class="profile-form"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="学号" prop="studentId">
                <el-input v-model="studentInfo.studentId" :disabled="true" placeholder="请输入学号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="studentInfo.name" :disabled="true" placeholder="请输入姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别" prop="gender">
                <el-select v-model="studentInfo.gender" :disabled="true" placeholder="请选择性别">
                  <el-option label="男" value="男"></el-option>
                  <el-option label="女" value="女"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属年级">
                <el-input v-model="studentInfo.grade" :disabled="true" placeholder="请输入年级"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属班级">
                <el-input v-model="studentInfo.className" :disabled="true" placeholder="请输入班级"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="phone">
                <el-input v-model="studentInfo.phone" :disabled="!isEditing" placeholder="请输入联系电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电子邮箱" prop="email">
                <el-input v-model="studentInfo.email" :disabled="!isEditing" placeholder="请输入电子邮箱"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="学院">
                <el-input v-model="studentInfo.college" :disabled="!isEditing" placeholder="请输入学院"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身高(米)">
                <el-input v-model="healthInfo.height" :disabled="!isEditing" placeholder="请输入身高"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="体重(公斤)">
                <el-input v-model="healthInfo.weight" :disabled="!isEditing" placeholder="请输入体重"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="BMI指数">
                <el-input v-model="healthInfo.bmi" disabled placeholder="自动计算"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="BMI状态">
                <el-input v-model="healthInfo.bmiStatus" disabled placeholder="根据BMI评估"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item v-if="isEditing" class="form-actions">
            <el-button type="primary" @click="submitForm">提交</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <!-- 体测资讯 -->
    <div v-else-if="activeTab === 'news'">
      <div class="news-section">
        <h2 class="section-title">体测资讯</h2>
        <div class="news-list">
          <div class="news-item" v-for="news in latestNews" :key="news.id">
            <div class="news-header">
              <div class="news-title">{{ news.title }}</div>
              <div class="news-date">{{ news.date }}</div>
            </div>
            <div class="news-content">{{ news.content || '暂无简要内容' }}</div>
            <div class="news-actions">
              <a href="javascript:void(0)" class="view-detail-btn" @click="viewNewsDetail(news.id)">查看详情并下载PDF</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 资讯详情弹窗 -->
    <el-dialog
      title="资讯详情"
      v-model:visible="newsDetailVisible"
      width="60%"
      :before-close="handleClose"
    >
      <div class="news-detail">
        <div class="news-detail-title">{{ currentNews.title }}</div>
        <div class="news-detail-date">{{ currentNews.date }}</div>
        <div class="news-detail-content">{{ currentNews.content }}</div>
        
        <!-- 体测评分标准PDF下载 -->
        <div v-if="currentNews.id === 2" class="pdf-download">
          <p>点击下方按钮下载完整PDF文件：</p>
          <el-button type="primary" @click="downloadPdf('标准')">下载PDF</el-button>
          <div class="pdf-hint">
            <small style="color: #909399;">
              如果无法下载，请确保PDF文件已正确放置在
              <br>D:\创新创业\体测教师端\student-fitness-system\public\pdf\
              <br>目录下，并命名为"体测评分标准.pdf"
            </small>
          </div>
        </div>
        
        <!-- 健康饮食指南PDF下载 -->
        <div v-if="currentNews.id === 3" class="pdf-download">
          <p>点击下方按钮下载完整PDF文件：</p>
          <el-button type="primary" @click="downloadPdf('饮食指南')">下载PDF</el-button>
          <div class="pdf-hint">
            <small style="color: #909399;">
              如果无法下载，请确保PDF文件已正确放置在
              <br>D:\创新创业\体测教师端\student-fitness-system\public\pdf\
              <br>目录下，并命名为"健康饮食指南.pdf"
            </small>
          </div>
        </div>
        
        <!-- 体测通知PDF下载 -->
        <div v-if="currentNews.id === 1" class="pdf-download">
          <p>点击下方按钮下载完整PDF文件：</p>
          <el-button type="primary" @click="downloadPdf('通知')">下载PDF</el-button>
          <div class="pdf-hint">
            <small style="color: #909399;">
              如果无法下载，请确保PDF文件已正确放置在
              <br>D:\创新创业\体测教师端\student-fitness-system\public\pdf\
              <br>目录下，并命名为"体测通知.pdf"
            </small>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 体测补考 -->
    <div v-if="activeTab === 'makeup'">
      <!-- 补考申请表单 -->
      <el-card class="content-card">
        <div slot="header" class="card-header">
          <span>体测补考申请</span>
        </div>
        <el-form
          ref="makeupForm"
          :model="makeupApplication"
          :rules="makeupRules"
          label-width="120px"
          class="makeup-form"
        >
          <el-form-item label="考试项目" prop="eventName">
            <el-select v-model="makeupApplication.eventName" placeholder="请选择考试项目">
              <el-option label="50米跑" value="50m"></el-option>
              <el-option label="1000米跑(男)" value="1000m"></el-option>
              <el-option label="800米跑(女)" value="800m"></el-option>
              <el-option label="立定跳远" value="longJump"></el-option>
              <el-option label="引体向上(男)" value="pullUp"></el-option>
              <el-option label="仰卧起坐(女)" value="sitUp"></el-option>
              <el-option label="坐位体前屈" value="sitAndReach"></el-option>
            </el-select>
          </el-form-item>

          <!-- 原活动选择 -->
          <el-form-item label="原活动" prop="originalActivityId">
            <el-select v-model="makeupApplication.originalActivityId" placeholder="请选择原活动（可选）">
              <el-option 
                v-for="activity in activityList" 
                :key="activity.id" 
                :label="activity.name" 
                :value="activity.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="补考原因" prop="reason">
            <el-input v-model="makeupApplication.reason" type="textarea" rows="4"></el-input>
          </el-form-item>

          <el-form-item label="申请日期" prop="applyDate">
            <el-date-picker
              v-model="makeupApplication.applyDate"
              type="date"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              placeholder="选择申请日期"
            ></el-date-picker>
          </el-form-item>

          <!-- 证明材料已移除 -->

          <el-form-item class="form-actions">
            <el-button type="primary" @click="submitMakeupForm">提交申请</el-button>
            <el-button @click="resetMakeupForm">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>



    <!-- 体测指导视频 -->
    <div v-else-if="activeTab === 'videos'">
      <el-card class="content-card">
        <div slot="header" class="card-header">
          <span>体测指导视频</span>
        </div>
        <div class="video-list">
          <el-row :gutter="20">
            <el-col :span="8" v-for="(video, index) in videoList" :key="index">
              <el-card class="video-card">
                <div class="video-cover">
                <img v-if="video.cover" :src="video.cover" alt="{{ video.title }}">
                <span v-else>{{ video.title }}</span>
              </div>
                <div class="video-info">
                  <div class="video-name">{{ video.title }}</div>
                  <div class="video-duration">{{ video.duration }}</div>
                  <el-button type="primary" size="small" @click="playVideo(video.id)">
                    播放
                  </el-button>
                </div>
              </el-card>
            </el-col>
        </el-row>
      </div>
      </el-card>
    </div>

  <!-- 资讯详情弹窗已移除，改为直接在页面显示 -->
  
  <!-- 视频播放弹窗 -->
  <el-dialog
    :title="currentVideo.title || '视频播放'"
    v-model="videoPlayerVisible"
    width="80%"
    :before-close="handleVideoPlayerClose"
    modal
    destroy-on-close
    append-to-body
    center
  >
    <div class="video-player-container">
        <video 
          :src="currentVideo.videoPath" 
          controls 
          muted
          playsinline
          class="video-player"
          width="100%"
          height="auto"
        >
          您的浏览器不支持HTML5视频播放
        </video>
      </div>
  </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, getCurrentInstance, computed } from 'vue';
import { ElMessage } from 'element-plus';
import axios from 'axios';
import request from '@/utils/request';

// 资讯详情弹窗相关变量
const newsDetailVisible = ref(false);
const currentNews = ref({
  id: 0,
  title: '',
  date: '',
  content: '',
  hasPdf: false
});

// 处理资讯详情弹窗关闭
const handleClose = () => {
  newsDetailVisible.value = false;
  // 重置currentNews，避免下次打开时显示旧数据
  currentNews.value = {
    id: 0,
    title: '',
    date: '',
    content: '',
    hasPdf: false
  };
};

const { proxy } = getCurrentInstance();

import { useRoute } from 'vue-router';

const route = useRoute();

// 根据路由参数确定当前显示的标签
const activeTab = computed(() => {
  const subPath = route.path.split('/').pop();
  return ['info', 'news', 'videos', 'makeup'].includes(subPath) ? subPath : 'info';
});

// 编辑状态
const isEditing = ref(false);

// 封面图片路径 - 直接在模板中使用

// 学生信息
const studentInfo = reactive({
  studentId: '',
  name: '',
  gender: '',
  phone: '',
  email: '',
  college: '',
  major: '',
  className: '',
  grade: ''
});

// 健康信息
const healthInfo = reactive({
  height: '',
  weight: '',
  bmi: '',
  bmiStatus: ''
});

// 体测补考申请表单数据
const makeupApplication = reactive({
  eventName: '',
  reason: '',
  applyDate: '',
  originalActivityId: '' // 添加原活动ID字段
});

// 体测补考文件列表
const fileList = ref([]);
// 添加原活动列表
const activityList = ref([]);
// 体测补考表单验证规则
const makeupRules = {
  eventName: [
    { required: true, message: '请选择考试项目', trigger: 'change' }
  ],
  reason: [
    { required: true, message: '请输入补考原因', trigger: 'blur' },
    { min: 10, max: 200, message: '补考原因长度在 10 到 200 个字符', trigger: 'blur' }
  ],
  applyDate: [
    { required: true, message: '请选择申请日期', trigger: 'change' }
  ]
};

// 体测资讯数据
const newsList = ref([]);
const latestNews = ref([]);



// 指导视频数据
const videoList = ref([]);
// 视频播放弹窗的可见性状态
const videoPlayerVisible = ref(false);
// 当前选中的视频
const currentVideo = ref({});

// 日期格式化函数
const formatDate = (row, column, cellValue) => {
  if (!cellValue) return '';
  // 处理日期范围格式，只显示年月日
  if (cellValue.includes('至')) {
    const [start, end] = cellValue.split('至');
    // 提取年月日部分
    const startDate = start.trim().split('T')[0];
    const endDate = end.trim().split('T')[0];
    return `${startDate} 至 ${endDate}`;
  }
  // 单一日期格式
  return cellValue.split('T')[0];
};

// 表单验证规则
const profileRules = {
  studentId: [
    { required: true, message: '请输入学号', trigger: 'blur' }
  ],
  name: [
    { required: true, message: '请输入姓名', trigger: 'blur' }
  ],
  gender: [
    { required: true, message: '请选择性别', trigger: 'change' }
  ],
  phone: [
    { required: true, message: '请输入联系电话', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
  ],
  email: [
    { required: true, message: '请输入电子邮箱', trigger: 'blur' },
    { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
  ]
};

// 移除标签切换函数，由路由控制显示内容

// 切换编辑状态
const toggleEdit = () => {
  isEditing.value = !isEditing.value;
};

// 提交表单
const submitForm = async () => {
  try {
    const form = proxy.$refs.profileForm;
    await form.validate();

    // 创建提交数据对象，明确列出所有需要提交的字段，避免phone字段导致的问题
    const submitData = {
      studentId: studentInfo.studentId,
      name: studentInfo.name,
      gender: studentInfo.gender,
      grade: studentInfo.grade,
      className: studentInfo.className,
      contactInfo: studentInfo.phone, // 将联系电话映射到后端期望的contactInfo字段
      email: studentInfo.email,
      college: studentInfo.college,
      major: studentInfo.major,
      // 不包含phone字段，避免字段重复问题
      // 健康信息单独处理
      height: healthInfo.height,
      weight: healthInfo.weight
    };

    const response = await request.put('/student/profile', submitData);
    if (response.code === 200) {
      ElMessage.success('信息更新成功');
      
      // 由于身高体重可能已更改，重新获取学生信息以更新BMI和健康状况
      fetchStudentInfo();
      
      isEditing.value = false;
    } else {
      ElMessage.error('信息更新失败');
    }
  } catch (error) {
    console.error('提交表单失败:', error);
    ElMessage.error('提交表单失败，请重试');
  }
};

// 重置表单
const resetForm = () => {
  proxy.$refs.profileForm.resetFields();
};

// 查看资讯详情并下载PDF
const viewNewsDetail = (id) => {
  try {
    console.log('查看资讯详情并下载PDF，ID:', id);
    
    // 直接下载对应PDF文件
    console.log('开始下载PDF文件');
    if (id === 1) {
      downloadPdf('通知');
    } else if (id === 2) {
      downloadPdf('标准');
    } else if (id === 3) {
      downloadPdf('饮食指南');
    } else {
      // 如果是其他ID，尝试从列表中查找并下载
      const news = latestNews.value.find(item => item.id === id);
      if (news && news.filePath) {
        // 如果有filePath，使用filePath下载
        downloadPdfByPath(news.filePath, news.title + '.pdf');
      } else {
        ElMessage.warning('未找到对应的PDF文件');
      }
    }
    
  } catch (error) {
    console.error('下载PDF失败:', error);
    ElMessage.error('下载PDF失败，请重试');
  }
};

// 根据文件路径下载PDF
const downloadPdfByPath = (filePath, fileName) => {
  try {
    console.log('根据路径下载PDF文件:', filePath);
    
    // 创建下载链接
    const link = document.createElement('a');
    link.href = filePath;
    link.download = fileName || '资讯文件.pdf';
    
    // 强制在当前页面打开链接（如果下载失败）
    link.target = '_self';
    
    // 添加到文档并触发点击
    document.body.appendChild(link);
    
    // 使用延迟确保链接被正确添加
    setTimeout(() => {
      console.log('触发下载点击事件');
      link.click();
      
      // 移除链接
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);
      
      ElMessage.success(`开始下载${fileName}`);
    }, 0);
    
  } catch (error) {
    console.error('下载PDF失败:', error);
    ElMessage.error(`无法下载PDF文件。`);
  }
};

// 提交补考申请
const submitMakeupForm = async () => {
  try {
    const form = proxy.$refs.makeupForm;
    await form.validate();

    // 构建符合后端要求的请求体
    const formData = {
      studentId: studentInfo.studentId, // 添加学生ID
      eventName: makeupApplication.eventName,
      reason: makeupApplication.reason,
      applyDate: makeupApplication.applyDate,
      originalActivityId: makeupApplication.originalActivityId, // 添加原活动ID
      fileList: fileList.value.length > 0 ? fileList.value.map(file => file.name) : []
    };
// 使用完整路径
    const response = await request.post('/api/student/makeup-exam', formData);
    if (response.code === 200) {
      console.log('补考申请提交成功');
      // 显示成功消息
      ElMessage.success('补考申请提交成功');
      resetMakeupForm();
    } else {
      ElMessage.error(response.message || '补考申请提交失败');
    }
  } catch (error) {
    console.error('提交补考申请失败:', error);
    ElMessage.error('提交补考申请失败，请重试');
  }
};

// 重置补考申请
const resetMakeupForm = () => {
  proxy.$refs.makeupForm.resetFields();
  fileList.value = [];
  makeupApplication.originalActivityId = ''; // 重置原活动ID
};

// 获取学生参加过的活动列表
const fetchStudentActivities = async () => {
  try {
    // 调用后端接口获取真实的活动列表
    const response = await request.get('/student/activities');
    if (response.code === 200 && response.data && Array.isArray(response.data)) {
      // 确保返回的数据格式正确，只保留需要的id和name字段
      activityList.value = response.data.map(activity => ({
        id: activity.activityId || activity.id,
        name: activity.activityName || activity.name || '未知活动'
      })).filter(activity => activity.id && activity.name); // 过滤掉无效数据
      
      // 如果没有活动数据，使用默认数据
      if (activityList.value.length === 0) {
        activityList.value = [
          { id: '501', name: '2021夏季体测' },
          { id: '502', name: '2023冬季体测' },
          { id: '503', name: '2024春季体测' }
        ];
      }
    } else {
      // 接口调用失败，使用默认数据
      activityList.value = [
        { id: '501', name: '2021夏季体测' },
        { id: '502', name: '2023冬季体测' },
        { id: '503', name: '2024春季体测' }
      ];
    }
  } catch (error) {
    console.error('获取活动列表失败:', error);
    // 异常时使用默认数据
    activityList.value = [
      { id: '501', name: '2021夏季体测' },
      { id: '502', name: '2023冬季体测' },
      { id: '503', name: '2024春季体测' }
    ];
  }
};

// 在组件挂载或学生信息获取后调用获取活动列表
onMounted(async () => {
  await fetchStudentInfo();
  // 移除未定义的函数调用
  // await fetchLatestNews();
  // await fetchVideoList();
  await fetchStudentActivities(); // 获取活动列表
});

// 处理文件上传成功
const handleUploadSuccess = (response, file, fileList) => {
  if (response.code === 200) {
    ElMessage.success('文件上传成功');
  } else {
    ElMessage.error('文件上传失败');
  }
};



// 下载PDF文件
const downloadPdf = (type) => {
  try {
    console.log('尝试下载PDF文件，类型:', type);
    
    // 构建文件路径
    let filePath = '';
    let fileName = '';
    
    if (type === '标准') {
      filePath = '/pdf/体测评分标准.pdf';
      fileName = '体测评分标准.pdf';
    } else if (type === '饮食指南') {
      filePath = '/pdf/健康饮食指南.pdf';
      fileName = '健康饮食指南.pdf';
    } else {
      filePath = '/pdf/体测通知.pdf';
      fileName = '体测通知.pdf';
    }
    
    console.log('PDF文件路径:', filePath);
    console.log('PDF文件名称:', fileName);
    
    // 检查public目录下是否存在pdf目录
    // 创建下载链接
    const link = document.createElement('a');
    link.href = filePath;
    link.download = fileName;
    
    // 强制在当前页面打开链接（如果下载失败）
    link.target = '_self';
    
    // 添加到文档并触发点击
    document.body.appendChild(link);
    
    // 使用延迟确保链接被正确添加
    setTimeout(() => {
      console.log('触发下载点击事件');
      link.click();
      
      // 移除链接
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);
      
      ElMessage.success(`开始下载${fileName}`);
    }, 0);
    
  } catch (error) {
    console.error('下载PDF失败:', error);
    ElMessage.error(`无法下载PDF文件。请确保文件已放置在正确位置：D:\\创新创业\\体测教师端\\student-fitness-system\\public\\pdf\\`);
  }
};



// 直接测试资讯详情弹窗的函数


// 播放视频函数
const playVideo = (id) => {
  console.log('播放视频ID:', id);
  // 查找对应ID的视频
  const video = videoList.value.find(item => item.id === id);
  if (video) {
    console.log('找到视频:', video.title, video.videoPath);
    // 立即更新当前视频信息
    currentVideo.value = { ...video };
    
    // 检查视频文件是否存在
    checkVideoExists(video.videoPath);
    
    // 强制刷新currentVideo对象以确保响应式更新
    currentVideo.value = { ...currentVideo.value };
    
    // 立即显示视频弹窗，移除延时以避免问题
    console.log('准备显示视频弹窗');
    videoPlayerVisible.value = true;
    
    // 再次确认弹窗状态
    console.log('视频弹窗状态设置为:', videoPlayerVisible.value);
  } else {
    console.warn('未找到ID为', id, '的视频');
  }
};

// 检查视频文件是否存在
const checkVideoExists = async (videoPath) => {
  try {
    console.log('正在检查视频文件:', videoPath);
    // 由于fetch可能受到CORS限制，我们简化检查逻辑
    // 直接认为文件存在，让浏览器的video标签自行处理加载
    console.log('假设视频文件存在，让浏览器尝试加载');
    ElMessage.success('视频加载成功');
  } catch (error) {
    console.error('检查视频文件失败:', error);
    ElMessage.error('加载视频时发生错误');
  }
};

// 处理视频播放弹窗关闭
const handleVideoPlayerClose = () => {
  videoPlayerVisible.value = false;
};

// 获取学生信息
const fetchStudentInfo = async () => {
  try {
    console.log('开始获取学生个人信息');
    
    // 从localStorage获取用户信息和token
    const token = localStorage.getItem('token');
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    
    console.log('当前用户信息:', userInfo);
    console.log('当前token:', token);
    
    if (!token) {
      console.error('未找到token，请重新登录');
      ElMessage.error('请先登录');
      return;
    }
    
    // 调用后端个人信息接口
    const response = await request.get('/student/app/personal-info', {}, {
      headers: {
        'Authorization': token
      }
    });
    
    console.log('后端响应:', response);
    
    if (response.code === 200 && response.data) {
      // 将后端返回的数据赋值给studentInfo
      const studentData = response.data;
      studentInfo.studentId = studentData.studentId || '';
      studentInfo.name = studentData.name || '';
      studentInfo.gender = studentData.gender || '';
      // 从后端返回的数据中获取联系电话，使用contactInfo字段
      studentInfo.phone = studentData.contactInfo || '';
      studentInfo.email = studentData.email || '';
      studentInfo.college = studentData.college || '';
      studentInfo.major = studentData.major || '';
      studentInfo.className = studentData.className || '';
      // 使用正确的grade字段映射年级
      studentInfo.grade = studentData.grade || '';
      
      // 更新身高和体重信息
      healthInfo.height = studentData.height || '';
      healthInfo.weight = studentData.weight || '';
      healthInfo.bmi = studentData.bmi || '';
      healthInfo.bmiStatus = studentData.bmiStatus || '';
      
      // 如果有健康信息也一并更新
      if (studentData.height) {
        healthInfo.height = studentData.height || '';
      healthInfo.weight = studentData.weight || '';
      }
      
      console.log('学生信息更新成功');
    } else {
      console.error('获取学生信息失败，响应状态码:', response.code, '消息:', response.message);
      ElMessage.error(response.message || '获取学生信息失败');
      
      // 如果是认证错误，跳转到登录页
    }
  } catch (error) {
    console.error('获取学生信息异常:', error);
    ElMessage.error('获取学生信息失败，请重试');
  }
};

// 获取资讯数据
const fetchNews = async () => {
  try {
    // 尝试从后端API获取资讯数据
    const response = await request.get('/student/news');
    
    console.log('从后端获取到的资讯数据:', response);
    
    // 简化数据处理逻辑，直接使用后端返回的数据
    if (response && response.data) {
      let newsData = [];
      
      // 灵活处理各种可能的数据格式
      if (Array.isArray(response.data)) {
        newsData = response.data;
      } else if (response.data.newsList) {
        newsData = response.data.newsList;
      } else {
        // 尝试直接使用response.data，兼容后端可能的直接返回
        newsData = [response.data];
      }
      
      // 直接使用后端返回的数据，保留原始字段
      latestNews.value = newsData.map(news => ({
        ...news,
        id: news.id || news.resourceId || 0,
        date: news.date || news.publishTime || '',
        title: news.title || '',
        content: news.content || news.briefContent || '',
        filePath: news.filePath
      }));
      
      console.log('更新后的资讯数据:', latestNews.value);
    } else {
      console.log('后端未返回数据');
      latestNews.value = [];
    }
  } catch (error) {
    console.error('获取资讯数据失败:', error);
    // 错误时显示空数组，避免使用模拟数据
    latestNews.value = [];
    ElMessage.error('获取资讯数据失败，请稍后重试');
  }
};

// formatDate函数已在文件前面定义

// 体测活动数据已从Dashboard页面展示，个人信息页面不再获取活动数据

// 获取视频数据
const fetchVideos = () => {
  // 直接使用本地模拟视频数据
  videoList.value = [{id:1,title:'50米技巧训练',duration:'06:30',cover:'/img/50米跑步.jpg',videoPath:'/videos/50米跑技巧视频.mp4'},{id:2,title:'立定跳远训练方法',duration:'08:15',cover:'/img/立定跳远.jpg',videoPath:'/videos/立定跳远视频.mp4'},{id:3,title:'1000米跑耐力提升',duration:'10:45',cover:'/img/1000米跑.jpg',videoPath:'/videos/1000米跑视频.mp4'},{id:4,title:'引体向上技巧训练',duration:'09:20',cover:'/img/引体向上.jpg',videoPath:'/videos/引体向上.mp4'},{id:5,title:'坐位体前屈训练方法',duration:'07:45',cover:'/img/坐位体前屈.jpg',videoPath:'/videos/坐位体前屈.mp4'},{id:6,title:'仰卧起坐技巧训练',duration:'08:30',cover:'/img/仰卧起坐.jpg',videoPath:'/videos/仰卧起坐.mp4'}];
};

// 在组件挂载时获取数据
onMounted(() => {
  // 检查当前路径是否包含'/student/records'
  if (window.location.pathname.includes('/student/records')) {
    activeTab.value = 'scores';
  }
  
  fetchStudentInfo();
    fetchNews();
    fetchVideos();
  
  // 检查localStorage中是否有要显示的资讯详情
  console.log('Profile页面挂载，检查localStorage');
  // 尝试多次获取localStorage数据，确保在页面完全加载后获取
  setTimeout(() => {
    const savedNewsDetail = localStorage.getItem('currentNewsDetail');
    console.log('localStorage中的currentNewsDetail:', savedNewsDetail);
    if (savedNewsDetail) {
      try {
        const newsDetail = JSON.parse(savedNewsDetail);
        console.log('解析后的资讯详情:', newsDetail);
        
        // 确保数据结构完整
        if (newsDetail && newsDetail.title && newsDetail.content) {
          console.log('资讯详情数据有效');
          // 强制更新currentNews，确保响应式更新
          currentNews.value = {
            ...newsDetail,
            id: newsDetail.id || 0,
            date: newsDetail.date || '',
            hasPdf: newsDetail.hasPdf || false
          };
          console.log('设置currentNews后的数据:', currentNews.value);
          
          // 使用setTimeout确保DOM已经更新
          setTimeout(() => {
            newsDetailVisible.value = true;
            console.log('设置newsDetailVisible为true后的值:', newsDetailVisible.value);
            
            // 再次确认弹窗状态
            setTimeout(() => {
              console.log('弹窗状态确认:', newsDetailVisible.value);
            }, 100);
          }, 0);
          
          // 延迟清除localStorage，确保数据已经被完全使用
          setTimeout(() => {
            localStorage.removeItem('currentNewsDetail');
            console.log('已清除localStorage中的currentNewsDetail');
          }, 500);
        } else {
          console.warn('资讯详情数据不完整:', newsDetail);
        }
      } catch (error) {
        console.error('解析资讯详情失败:', error);
        // 尝试手动解析可能的JSON格式问题
        try {
          // 移除可能的格式问题
          const cleanData = savedNewsDetail.replace(/^"|"$/g, '').replace(/\\"/g, '"');
          const newsDetail = JSON.parse(cleanData);
          console.log('尝试清理后解析成功:', newsDetail);
          currentNews.value = newsDetail;
          newsDetailVisible.value = true;
        } catch (innerError) {
          console.error('清理后解析仍然失败:', innerError);
        }
      }
    } else {
      console.log('localStorage中没有currentNewsDetail数据');
      // 如果没有从Dashboard跳转过来的数据，检查当前路由参数中是否有newsId
      const urlParams = new URLSearchParams(window.location.search);
      const newsId = urlParams.get('newsId');
      if (newsId) {
        console.log('URL中有newsId参数:', newsId);
        // 尝试从已加载的newsList中查找对应的资讯
        const news = newsList.value.find(item => item.id === parseInt(newsId));
        if (news) {
          console.log('根据URL参数找到资讯:', news);
          currentNews.value = news;
          newsDetailVisible.value = true;
        } else {
          console.warn('根据URL参数未找到对应资讯');
        }
      }
    }
  }, 100);
});
</script>

<style scoped>
.student-profile {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 欢迎语样式 */
.welcome-section {
  margin-bottom: 30px;
}

.welcome-title {
  font-size: 16px;
  font-weight: normal;
  color: #606266;
  margin: 0 0 10px 0;
}

.welcome-message {
  font-size: 30px;
  font-weight: normal;
  color: #409eff;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
}

.nav-card {
  margin-bottom: 20px;
}

.nav-container {
  padding: 10px 0;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
}

.edit-btn {
  align-self: flex-end;
}

.profile-form, .health-form, .makeup-form {
  padding: 30px 0;
}

/* 增加表单行之间的间距 */
.profile-form .el-form-item {
  margin-bottom: 25px;
}

/* 为体测补考表单增加更大的字段间距和字体大小 */
.makeup-form .el-form-item {
  margin-bottom: 55px; /* 更大的间距 */
  font-size: 26px; /* 增大字体大小 */
}

.makeup-form .el-form-item__label {
  font-size: 18px; /* 增大标签字体 */
  font-weight: 500;
}

.makeup-form .el-input,
.makeup-form .el-select,
.makeup-form .el-date-editor {
  font-size: 18px; /* 增大输入控件字体 */
}

/* 特别调整补考原因输入框，使其更大 */
.makeup-form .el-input__inner {
  font-size: 18px; /* 输入框内文字大小 */
  padding: 12px 14px; /* 增加输入框内边距 */
}

/* 调整多行文本输入框的最小高度 */
.makeup-form .el-textarea {
  width: 100%;
}

.makeup-form .el-textarea__inner {
  font-size: 18px;
  min-height: 160px; /* 大幅增加文本域的高度 */
  padding: 15px;
  line-height: 1.6;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}



.news-list, .activity-list, .video-list {
  padding: 10px 0;
}

/* 体测资讯样式 - 与Dashboard保持一致 */
.news-section {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #409eff;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.news-item {
  padding: 30px;
  background-color: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  transition: all 0.3s ease;
  margin-bottom: 20px;
}

.news-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.news-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}

.news-date {
  font-size: 14px;
  color: #909399;
  margin-bottom: 15px;
}

.news-content {
  font-size: 16px;
  color: #606266;
  line-height: 1.6;
  margin-bottom: 20px;
  max-height: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.view-detail-btn {
  font-size: 14px;
  color: #409eff;
  text-decoration: none;
  padding: 8px 16px;
  background-color: #ecf5ff;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.news-item:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-color: #e4e7ed;
}

.news-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.news-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 0;
  margin-bottom: 0;
  cursor: default;
}

.news-date {
  font-size: 14px;
  color: #909399;
  margin-bottom: 0;
}

.news-content {
  font-size: 14px;
  color: #606266;
  margin-bottom: 15px;
  line-height: 1.6;
  display: block;
  -webkit-line-clamp: none;
}

.news-actions {
  text-align: right;
}

.view-detail-btn {
  color: #409eff;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s ease;
}

.view-detail-btn:hover {
  background-color: #409eff;
  color: #ffffff;
  text-decoration: none;
}

/* 原有样式 */
.news-detail {
  padding: 10px 0;
}

.news-detail-date {
  color: #909399;
  font-size: 12px;
  margin-bottom: 15px;
}

.news-detail-content {
  font-size: 14px;
  line-height: 1.8;
  color: #606266;
  margin-bottom: 20px;
  white-space: pre-wrap;
}

.pdf-download {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  text-align: center;
}

.video-tip {
  margin-top: 10px;
  padding-top: 10px;
  text-align: center;
  color: #909399;
  font-size: 12px;
}

.video-player-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
}

.video-player {
  max-height: 500px;
  border-radius: 4px;
}

.video-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.video-cover {
  width: 100%;
  height: 150px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  overflow: hidden;
  position: relative;
  border: 1px solid #ddd;
}

.video-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.video-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-cover span {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.video-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.video-name {
  font-weight: bold;
}

.video-duration {
  color: #909399;
  font-size: 12px;
}

/* 覆盖Element Plus中ElMessage组件的样式 */

/* 确保补考申请成功提示显示为绿色对勾样式 - 使用更强的选择器和更具体的样式 */
.el-message.makeup-success-message {
  background-color: #f0f9eb !important;
  border-color: #e1f3d8 !important;
  color: #67c23a !important;
  background-image: none !important;
}

.el-message.makeup-success-message .el-message__content {
  color: #67c23a !important;
}

.el-message.makeup-success-message .el-message__icon {
  color: #67c23a !important;
}

.el-message.makeup-success-message .el-message__icon:before {
  content: "\e606" !important;
  color: #67c23a !important;
}

/* 针对Element Plus的success类型消息的全局覆盖 */
.el-message--success {
  background-color: #f0f9eb !important;
  border-color: #e1f3d8 !important;
  color: #67c23a !important;
}

.el-message--success .el-message__content {
  color: #67c23a !important;
}

.el-message--success .el-message__icon {
  color: #67c23a !important;
}
</style>